import { render, staticRenderFns } from "./UserSummary.vue?vue&type=template&id=bdc85cf2&scoped=true&"
import script from "./UserSummary.vue?vue&type=script&lang=js&"
export * from "./UserSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc85cf2",
  null
  
)

export default component.exports